export enum ContentTypeRequisicaoEnum{
    APPLICATION_JSON = "application/json",
    APPLICATION_XML = "application/xml",
    TEXT_PLAIN = "text/plain",
    TEXT_HTML = "text/html",
    MULTIPART_FORM_DATA = "multipart/form-data",
    APPLICATION_X_WWW_FORM_URLENCODED = "application/x-www-form-urlencoded",
    APPLICATION_OCTET_STREAM = "application/octet-stream"
}
